module.exports = __webpack_public_path__ + "static/media/MobileDataGOLANGDESENDESISTEMASCOMMICROSERVICES.f282ed6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/golangdesenv/MobileDataGOLANGDESENDESISTEMASCOMMICROSERVICES.png
// module id = 98
// module chunks = 0